define(function () {
	var autoCompleteCollection = require('civicsCollections/core/autocomplete_collection.js');

	return autoCompleteCollection.extend({
		parse: function (data) {
			//console.log('parsing');
			var response = data.documents;
			return this.removeProp(response, '__type');
		},
		//end backbone functions//

		//hopefully temporary code to remove the __type variable and fees object in lookup.
		removeProp: function (obj, propToDelete) {
			for (var property in obj) {
				if (property === propToDelete) {
					delete obj[property];
				} else if (typeof obj[property] == 'object') {
					let objectToCheck = obj[property];
					delete obj.property;
					let newJsonData = this.removeProp(obj[property], propToDelete);
					obj[property] = newJsonData;
				}
			}
			return obj;
		}
	});
});